<template>
  <div class="dialog-wap">
    <el-dialog
      :model-value="visible"
      align-center
      width="480"
      title=""
      :before-close="handleClose"
    >
      <template #header>
        <div class="my-header">
          <h4 class="px-2 pb-3 text-lg text-[#262626] font-semibold">
            上传交付物
          </h4>
        </div>
      </template>
      <el-form
        ref="formRef"
        require-asterisk-position="right"
        label-position="top"
        :model="form"
        :rules="formRules"
      >
        <el-form-item prop="deliverFileList">
          <el-upload
            v-model:file-list="form.deliverFileList"
            class="upload-demo"
            :action="`${seleAction}`"
            :headers="{ Authorization:`Bearer ${getToken()}` }"
            accept=".zip, .rar, .7z"
            :before-upload="(file: any) => {
              const fileExt = file.name.split('.').pop().toLocaleLowerCase();
              if (!fileType.includes(fileExt)) {
                ElMessage.error('只能上传zip、rar、7z格式文件');
                return false;
              } else if (file.size / 1024 / 1024 > 10) {
                ElMessage.error('文件大小不能超过10MB');
                return false;
              } else {
                seleAction = UploadFileUrls.normal;
              }
              return true
            }"
            :on-success="(res: any) => {
              const file = res?.context || undefined;
              const v = form.deliverFileList[form.deliverFileList.length - 1];
              v.fileUrl = file?.fileUrl || file?.picUrl;
              v.fileName = `${file?.fileName}.${file?.fileType}`;
              v.fileType = file.fileType||file.picType;
            }"
            :on-exceed="() => ElMessage.error('最多上传5个')"
            :limit="5"
          >
            <el-button type="primary">
              <svg-icon icon="tabler:arrow-bar-up" />上传文件
            </el-button>
            <template #tip>
              <div class="el-upload__tip text-[#B8BFC3] h-[30px] w-[100%] leading-4	">
                文件格式支持：zip、rar、7z，每个文件小于10M， 最多上传5个
              </div>
            </template>
            <template #file="{ file } ">
              <div class="flex justify-between items-center px-2 cursor-pointer text-[#344767] text-sm h-[30px]">
                <div class="flex h-full items-center">
                  <svg-icon class="file-icon mr-2  !w-4 !h-4" icon="ph:file-text" />
                  <div class="w-[200px] truncate">
                    {{ file.name }}
                  </div>
                </div>
                <div class="flex h-full items-center">
                  <svg-icon class="file-icon main-primary-text mx-2  !w-4 !h-4" icon="tabler:arrow-bar-to-down" @click="downloadFile(file)" />
                  <svg-icon class="file-icon text-[#95A0B6]  !w-4 !h-4" icon="lets-icons:close-round" @click="removeFile(file)" />
                </div>
              </div>
            </template>
          </el-upload>
          <template #label>
            上传交付物（{{ form.deliverFileList?.length || 0 }}/5）
          </template>
        </el-form-item>
        <el-form-item prop="remark" label="交付说明">
          <el-input
            v-model="form.remark"
            type="textarea"
            :rows="3"
            class="w-[432px]"
            placeholder="请输入"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            :loading="saveBtnLoading" @click="handleClose"
          >
            取消
          </el-button>
          <el-button type="primary" :loading="saveBtnLoading" @click="handleSubmit">
            提交审批
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { PropType, ref } from 'vue';
import { downloadLinkFile, getToken } from '@core/api';
import { ElMessage } from 'element-plus';
import { EDutyDeliverStatus, IDutyDeliver } from '@core/main/types';
import { UploadFileUrls, deliverUpload } from '@core/main/api';
import { SvgIcon } from '@vue3/components';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  row: {
    type: Object as PropType<IDutyDeliver>,
    default: () => {},
  },
});

const emit = defineEmits<{close: []}>();

const saveBtnLoading = ref(false);

const formRef = ref();

const form = ref({
  deliverFileList: [],
  remark: '',
});

const formRules = ref({
  deliverFileList: [
    {
      required: true,
      message: '请上传交付材料', 
    },
  ], 
  remark: [
    {
      required: true,
      message: '请输入交付说明', 
    },
  ], 
});

const seleAction = ref(UploadFileUrls.normal);
const fileType = ['zip', 'rar', '7z'];

function removeFile(file: any) {
  form.value.deliverFileList = form.value.deliverFileList.filter((v) => v.uid !== file.uid);
}
/**
 * @function 下载文件
*/
function downloadFile(file: any) {
  downloadLinkFile(file.fileUrl);
}

function handleSubmit() {
  formRef.value.validate(async (valid) => {
    if (valid) {
      const params = {
        dutyId: Number(props.row.dutyId),
        id: Number(props.row.id),
        operateType: props.row.status == EDutyDeliverStatus.NOT_UPLOADED ? 0 : 1,
        ...form.value,
      };

      try {
        await deliverUpload(params);
        handleClose();
      } catch (error) {
        if ((error as Error).message) ElMessage.error((error as Error).message);
      }
    }
  });
  
}

function handleClose() {
  formRef.value.resetFields();
  emit('close');
}

</script>

<style lang="scss" scoped>

</style>
